<template>
  <el-menu
    :unique-opened="false"
    class="el-menu-vertical"
  >
    <template
      v-for="menu in props.menus"
      :key="menu.urlPath"
    >
      <drawer-nav-item
        v-if="menu.type === '1' || menu.type === '5'"
        :menu="menu"
        v-bind="$attrs"
      />
    </template>
  </el-menu>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import type { ResourcesChildrenTree } from '@y/types'
import DrawerNavItem from './DrawerNavItem.vue'

const props = defineProps({
  menus: {
    type: Array as PropType<ResourcesChildrenTree[]>,
    required: true,
  },
})
</script>

<style lang="less" scoped></style>
